import React from 'react'
import Navigator from '../../../components/common/Navigator'
import MaterialDownloadIcon from '../../../components/common/icons/MaterialDownload'
import { useAnnulReport } from './api' // Make sure path is correct

// Define the structure of a single report item
type ReportItem = {
  title: string
  file: string
  year: string
}

const AnnualReports = () => {
  const { data, isLoading, isError } = useAnnulReport()

  // Flatten and cast the API data into a typed array
  const reports: ReportItem[] = data?.data
    ? (Object.values(data.data).flat() as ReportItem[])
    : []

  return (
    <div className="lg:w-11/12 mx-auto p-4 lg:p-0 my-8">
      <Navigator title="Annual Reports" slug="ANNUALREPORTS" />
      <div>
        <h2 className="text-3xl font-bold mb-1">Annual Report</h2>
        <p className="text-gray-900 mb-4">Resources and Reference Materials</p>
        <hr className="border-t-1 border-primaryBlue mb-6" />

        {isLoading ? (
          <p>Loading...</p>
        ) : isError ? (
          <p className="text-red-600">Failed to load reports.</p>
        ) : reports.length === 0 ? (
          <p>No reports available.</p>
        ) : (
          <div className="overflow-x-auto rounded-md border border-gray-200">
            <table className="min-w-full text-sm text-left">
              <thead>
                <tr className="bg-rose-100 text-gray-800">
                  <th className="px-6 py-3 font-semibold">Title</th>
                  <th className="px-6 py-3 font-semibold text-center">Year</th>
                  <th className="px-6 py-3 font-semibold text-center">
                    File Access
                  </th>
                </tr>
              </thead>
              <tbody>
                {reports.map((item, index) => (
                  <tr
                    key={index}
                    className="border-t border-gray-200 hover:bg-gray-50 transition"
                  >
                    {/* <td className="px-6 py-4">{item.title}</td> */}
                    <td className="px-6 py-4">
                      {item?.title
                        ? item.title.charAt(0).toUpperCase() +
                          item.title.slice(1)
                        : ''}
                    </td>

                    <td className="px-6 py-4 text-center">{item.year}</td>
                    <td className="px-6 py-4 text-center">
                      <a
                        href={item.file}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-flex items-center gap-2 bg-rose-50 hover:bg-rose-100 text-sm text-gray-800 px-4 py-2 rounded-full transition"
                      >
                        <MaterialDownloadIcon />
                        Download
                      </a>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  )
}

export default AnnualReports
